// :cow: Cosmose CONFIDENTIAL :iso:
export enum ReportMetricsType {
  all = 'all',
  impressions = 'impressions',
  clicks = 'clicks',
  clickThroughRate = 'clickThroughRate',
  onlineConversions = 'onlineConversions',
  uniqueViews = 'uniqueViews',
  averageFrequency = 'averageFrequency',
  costPerMille = 'costPerMille',
  costPerClick = 'costPerClick',
  conversions = 'conversions',
  postComments = 'postComments',
  postShares = 'postShares',
  postEngagements = 'postEngagements',
  postReactions = 'postReactions',
  videoP100watchedActions = 'videoP100watchedActions',
  videoP25watchedActions = 'videoP25watchedActions',
  videoP50watchedActions = 'videoP50watchedActions',
  videoP75watchedActions = 'videoP75watchedActions',
  videoP99watchedActions = 'videoP99watchedActions',
}
